import type { ComponentProps } from "react"
import { Badge } from "@holigral/shared/ui/components/ui/badge"
import { AssignmentStatus } from "./model"
import { useT } from "@/i18n"

type BadgeStyle = {
  readonly variant: ComponentProps<typeof Badge>["variant"]
  readonly className?: string
}

const STYLES: Record<AssignmentStatus, BadgeStyle> = {
  [AssignmentStatus.Pending]: { variant: "secondary" },
  [AssignmentStatus.InProgress]: {
    variant: "outline",
    className:
      "border-blue-500/30 bg-blue-500/10 text-blue-600 dark:text-blue-400",
  },
  [AssignmentStatus.Submitted]: {
    variant: "outline",
    className:
      "border-amber-500/30 bg-amber-500/10 text-amber-600 dark:text-amber-400",
  },
  [AssignmentStatus.Evaluated]: {
    variant: "outline",
    className:
      "border-green-500/30 bg-green-500/10 text-green-600 dark:text-green-400",
  },
  [AssignmentStatus.Revoked]: {
    variant: "ghost",
    className: "text-muted-foreground line-through",
  },
}

type Props = {
  readonly status: AssignmentStatus
}

export default function StatusBadge({ status }: Props) {
  const { t } = useT("assignment")
  const { variant, className } = STYLES[status]

  return (
    <Badge variant={variant} className={className}>
      {t(`status.${status}`)}
    </Badge>
  )
}
